import { toast } from 'react-toastify';
import { Client } from "../api";
import authActions from '../actions/auth';
import { registerTypes, resetPasswordTypes } from '../actions/auth/types';
import { encodePassword, TIPO_DOC, SECURITY_LIMIT } from '../helpers';

export function registerClient(payload) {
  return (dispatch, getState) => {
    try {
      const copyClient = {
        ...payload,
        password: encodePassword(payload.password)
      };

      return Client.registerClient({ client: copyClient }).then(response => {
        if (response && response.success) {
          dispatch(authActions.registerSuccess('Tu usuario se creó con éxito. Te enviamos un email para que actives tu cuenta.'));
        } else {
          dispatch(authActions.registerFailed(response.message));
        }
      });
    } catch (error) {
      dispatch(authActions.registerFailed('Ocurrió un error al intentar registrar el cliente.'));
    }
  };
}

export function sendPolicyByMail(payload) {
  return (dispatch, getState) => {
    try {
      const { tipoDoc, nroDoc } = payload;
      let docText = "";
      
      dispatch(authActions.sendingPolicy(true));

      switch(tipoDoc) {
        case TIPO_DOC.CI: docText = "documento de identidad"; break;
        case TIPO_DOC.RUT: docText = "RUT"; break;
        case TIPO_DOC.ASSURED: docText = "número de asegurado"; break;
        default: 
      }

      if(!nroDoc) {
        toast.warn("Debes ingresar tu " + docText + " primero.");
      } else {
        return Client.sendPolicyByMail({ tipoDoc, nroDoc }).then(result => {
          if (result && result.success) {
            toast.success(`Se envió el número de póliza a la casilla ${result.email} asociada a tu ${docText}.`);
          } else {
            toast.warn(`No se encontró una casilla de correo asociada a tu ${docText}.`);
          }
        });
      }
      dispatch(authActions.sendingPolicy(false));
    } catch (error) {
      dispatch(authActions.sendingPolicy(false));
    }
  }
}

export function resetPassword(payload) {
  return (dispatch, getState) => {
    if (!payload.token) {
      dispatch(authActions.resetPasswordFailed('Fallo de seguridad, recargue la página y vuelva a intentarlo'));
      return;
    }

    return Client.validateToken({ token: payload.token }).then(dataCaptcha => {
      if (dataCaptcha && dataCaptcha.success && dataCaptcha.score >= SECURITY_LIMIT) {
        return Client.forgotPassword(payload).then(data => {
          if (data && data.success) {
            dispatch(authActions.resetPasswordSuccess());
          } else {
            dispatch(authActions.resetPasswordFailed(data.message));
          }
        });
      } else {
        dispatch(authActions.resetPasswordFailed('Fallo en validación de seguridad, vuelva a intentarlo mas tarde'));
      }
    });
  }
}

export function changePassword(payload) {
  return (dispatch, getState) => {
    return Client.changePassword({
      token: payload.token,
      newPassword: encodePassword(payload.newPassword),
    }).then(data => {
      if (data && data.success) {
        dispatch(authActions.changePasswordSuccess());
      } else {
        dispatch(authActions.changePasswordFailed(data.message));
      }
    });
  }
}